import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import GeneralInfo from '../components/GeneralInfo';
import ServicesGrid from '../components/ServicesGrid';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="Home">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero
          image="/assets/images/landing_page.jpeg"
          heightClass="min-h-[50vh] sm:min-h-[55vh] md:min-h-[60vh] lg:min-h-[70vh] xl:min-h-[75vh]"
          fit="cover"
          position={{
            xs: 'center center',
            sm: 'center center',
            md: 'center center',
            lg: 'center center',
            xl: 'center center',
            '2xl': 'center center'
          }}
          overlay={true}
          contentClassName="absolute inset-x-0 bottom-0 z-10 flex justify-center px-4 sm:px-6 lg:px-8 pb-24 sm:pb-28 lg:pb-32"
        >
          <div className="w-full max-w-6xl mx-auto text-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-white drop-shadow-lg">
              Therapeutic Residential Care for Vulnerable Young People
            </h1>
          </div>
        </Hero>
        <GeneralInfo />
        <ServicesGrid />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
